module.exports = __webpack_public_path__ + "img/2017_1.18499635.webp";